import { render, staticRenderFns } from "./BaseAnnouncementBanner.vue?vue&type=template&id=7bb4aa8e"
import script from "./BaseAnnouncementBanner.vue?vue&type=script&lang=js"
export * from "./BaseAnnouncementBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports